import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarComponent from '../LandingPage/Navbar';
import Footer from '../Footer/Footer';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import './About.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

const About = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [navExpanded, setNavExpanded] = useState(false);
  const [activeLink, setActiveLink] = useState('/about');
  const nextRef = useRef(null);
  const prevRef = useRef(null);

  const handleNavigateToLogin = () => {
    navigate('/login');
  };

  const handleNavClick = (link) => {
    setActiveLink(link);
    if (windowWidth <= 991) {
      setNavExpanded(false);
    }
  };

  const handleHomeNavigation = (section) => {
    navigate('/');
    // Add a small delay to ensure the page loads before scrolling to section
    setTimeout(() => {
      const element = document.querySelector(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div>
      <div className="about-page" style={{ 
        position: 'relative',
        background: 'linear-gradient(180deg, rgba(0, 68, 170, 0.85) 0%, rgba(0, 0, 0, 1) 340.63%), url("/aboutbg.gif")',
        backgroundSize: 'cover, cover',
        backgroundPosition: 'center, center',
        backgroundRepeat: 'no-repeat, no-repeat',
        overflow: 'hidden'
      }}>

        {/* Background with glowing wavy lines */}

        {/* Use the same navbar as homepage */}
        <div className="hero-background" id="home">
        {/* Desktop Navbar (hidden on mobile) */}
        <Navbar expand="lg" className={`landing-navbar ${scrolled ? 'mt-0' : windowWidth > 991 ? 'mt-0' : 'mt-0'}`} expanded={navExpanded} onToggle={setNavExpanded}>
          <Container className="navbar-container">
            <Navbar.Brand href="/" className="navbar-brand">
              <img src={process.env.PUBLIC_URL + `/maia_navbar.svg`} alt="maia Logo" className="maia-logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='navbar-dark' />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="main-nav me-auto">
                <Nav.Link 
                  onClick={() => handleHomeNavigation('#how')}
                  active={false} 
                  className={activeLink === '#how' ? 'xactive' : ''}
                  style={{ cursor: 'pointer' }}
                >How MAIA Works?</Nav.Link>
                <Nav.Link 
                  onClick={() => handleHomeNavigation('#aimodels')}
                  active={false} 
                  className={activeLink === '#aimodels' ? 'xactive' : ''}
                  style={{ cursor: 'pointer' }}
                >AI Models</Nav.Link>
                <Nav.Link 
                  onClick={() => handleHomeNavigation('#globalimpact')}
                  active={false} 
                  className={activeLink === '#globalimpact' ? 'xactive' : ''}
                  style={{ cursor: 'pointer' }}
                >Global Impact</Nav.Link>
                <Nav.Link 
                  onClick={() => {
                    navigate('/about');
                    if (windowWidth <= 991) setNavExpanded(false);
                  }}
                  active={false} 
                  className={activeLink === '/about' ? 'xactive' : ''}
                  style={{ cursor: 'pointer' }}
                >About</Nav.Link>
                <Nav.Link 
                  onClick={() => handleHomeNavigation('#faq')}
                  active={false} 
                  className={activeLink === '#faq' ? 'xactive' : ''}
                  style={{ cursor: 'pointer' }}
                >FAQ</Nav.Link>
                <Nav.Link 
                  href="mailto:hello@ask-maia.com" 
                  active={false} 
                  className={activeLink === 'mailto:hello@ask-maia.com' ? 'xactive' : ''}
                  style={{ cursor: 'pointer' }}
                >Contact</Nav.Link>
              </Nav>
              <div className="nav-buttons">
                <Button className="login-btn p-3 px-5" onClick={() => { navigate('/chat'); if (windowWidth <= 991) setNavExpanded(false); }}>Login</Button>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

        {/* Main content area */}
        <main className="about-main">
          <div className="content-container">
            <div className="about-content">
              <h1 className="about-title">About Us</h1>
              <h2 className="about-tagline">
                MAIA: Real-Time Clinical Intelligence. Right When You Need It.
              </h2>
              <p className="about-description">
                MAIA (Medical AI Assistant) is a next-generation clinical decision support tool built by physicians, for physicians. Designed to assist anesthesiologists, pain specialists, and perioperative teams, MAIA delivers real-time, trusted, and context-aware guidance at the point of care — in the OR, at the bedside, or on the move.              
              </p>
            </div>
          </div>
        </main>
      </div>

      {/* What makes MAIA different section */}
      <section className="what-makes-different-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="what-makes-content">
                <h2 className="what-makes-title">
                  What makes MAIA different?
                </h2>
                <p className="what-makes-text">
                  It goes beyond generic AI chatbots. MAIA is trained on three decades of NYSORA’s peer-reviewed content — including textbooks, procedural videos, diagrams, and clinical protocols — and built with specialty and role-awareness at its core. It tailors answers to your clinical context, whether you're managing a complex case or checking a quick dose.                
                </p>
                <h3 className="what-makes-mission">
                  MAIA's mission is simple:
                </h3>
                <p className="what-makes-mission-text">
                  Empower clinicians with Intelligent Clinical Support at the Point of Care to improve safety and patient outcomes. <br/> Delivering real-time information guidance - exactly when and where it’s needed most.               
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="what-makes-visual">
                <img src={process.env.PUBLIC_URL + '/waves.png'} alt="waves" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
        <div className="container section-dots-divider mt-5 mb-5"></div>
      </section>

      {/* Built by Clinicians and Technologists section */}
      <section className="built-by-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="built-by-content text-center">
                <h2 className="built-by-title">
                  Built by Clinicians and Technologists
                </h2>
                <p className="built-by-description">
                  MAIA was co-created by Admir Hadzic, MD — founder of NYSORA and a globally recognized leader in regional anesthesia — alongside a founding team of practicing clinicians, product leaders, and AI engineers. The co-founders and advisors also include seasoned professionals from Amazon, J.P. Morgan, and TikTok, uniting deep expertise in healthcare, education, and frontier AI innovation.                
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-4 mb-5">
            <div className="col-lg-4 col-md-4 col-sm-12 mb-5">
              <div className="team-card team-card-admir">
                <div className="team-member-photo">
                  <img src={process.env.PUBLIC_URL + '/aboutadmir3.png'} alt="Admir Hadzic, MD" className="img-fluid" />
                </div>
              </div>
              <div className="team-member-info">
                <a href="https://www.linkedin.com/in/hadzic-admir/" target="_blank" rel="noopener noreferrer" className="name-link">
                  <h3 className="team-member-name">Admir Hadzic, <span>MD</span></h3>
                </a>
                <a href="https://www.linkedin.com/in/hadzic-admir/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="#0077B5"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-5">
              <div className="team-card team-card-charles">
                <div className="team-member-photo">
                  <img src={process.env.PUBLIC_URL + '/charlie.png'} alt="Charles Nguyen" className="img-fluid" />
                </div>
              </div>
              <div className="team-member-info">
                <a href="https://www.linkedin.com/in/charlesvnguyen/" target="_blank" rel="noopener noreferrer" className="name-link">
                  <h3 className="team-member-name">Charles Nguyen</h3>
                </a>
                <a href="https://www.linkedin.com/in/charlesvnguyen/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="#0077B5"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-5">
              <div className="team-card team-card-sabina">
                <div className="team-member-photo">
                  <img src={process.env.PUBLIC_URL + '/sabina2.png'} alt="Sabina Saljic" className="img-fluid" />
                </div>
              </div>
              <div className="team-member-info">
                <a href="https://www.linkedin.com/in/sabinasaljic/" target="_blank" rel="noopener noreferrer" className="name-link">
                  <h3 className="team-member-name">Sabina Saljic</h3>
                </a>
                <a href="https://www.linkedin.com/in/sabinasaljic/" target="_blank" rel="noopener noreferrer" className="linkedin-link">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="#0077B5"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="testimonials-section bgblue container-fluid" style={{
        borderRadius: '0',
        marginTop: '0',
        overflow: 'hidden',
      }}>
      <h2 className="testimonials-title">Trusted by Doctors Around the World</h2>
      <div className="testimonials-container">
        <div className="testimonials-quote-icon">
          <svg width="119" height="104" viewBox="0 0 119 104" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.540039 96.8311V41.8018C0.540039 29.3831 4.75553 19.7559 13.1865 12.9199C21.6175 5.97005 33.6374 1.69759 49.2461 0.102539V26.9336C40.1315 28.1868 33.1247 30.5225 28.2256 33.9404C23.3265 37.3584 20.0794 42.1436 18.4844 48.2959H49.2461V96.8311H0.540039ZM118.289 6.59668V61.626C118.289 74.0446 114.074 83.7288 105.643 90.6787C97.2116 97.5146 85.1917 101.73 69.583 103.325V76.4941C78.6976 75.2409 85.7044 72.9053 90.6035 69.4873C95.5026 66.0693 98.7497 61.2842 100.345 55.1318H69.583V6.59668H118.289Z" fill="#C8C8C8"/>
          </svg>
        </div>
        
        <Swiper
          modules={[Pagination, Autoplay, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{
            clickable: true,
            el: '.testimonials-pagination',
          }}
          navigation={{
            nextEl: nextRef.current,
            prevEl: prevRef.current,
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop={true}
          className="testimonials-swiper"

        >
          <SwiperSlide>
            <div className="testimonial-card bgbluecard">
              <div className="testimonial-header">
                <div className="testimonial-profile">
                  <img src="https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVyc29ufGVufDB8fDB8fHww" alt="Dr. John Doe" className="testimonial-avatar" />
                </div>
                <div className="testimonial-rating">
                  <div className="rating-score">5.0 / 5</div>
                  <div className="rating-stars">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="testimonial-name">Dr. John Doe</div>
              <div className="testimonial-text">
                "MAIA has revolutionized how I approach patient care. The instant access to evidence-based information has significantly improved my decision-making process and patient outcomes."
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div className="testimonial-card bgbluecard">
              <div className="testimonial-header">
                <div className="testimonial-profile">
                  <img src="https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fHww" alt="Dr. Sarah Johnson" className="testimonial-avatar" />
                </div>
                <div className="testimonial-rating">
                  <div className="rating-score">5.0 / 5</div>
                  <div className="rating-stars">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="testimonial-name">Dr. Sarah Johnson</div>
              <div className="testimonial-text">
                "The role-aware responses and real-time support have made a tremendous difference in my practice. MAIA truly understands the needs of healthcare professionals."
              </div>
            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div className="testimonial-card bgbluecard">
              <div className="testimonial-header">
                <div className="testimonial-profile">
                  <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmFuZG9tJTIwcGVvcGxlfGVufDB8fDB8fHww" alt="Dr. Michael Chen" className="testimonial-avatar" />
                </div>
                <div className="testimonial-rating">
                  <div className="rating-score">5.0 / 5</div>
                  <div className="rating-stars">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75492L10 0Z"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="testimonial-name">Dr. Michael Chen</div>
              <div className="testimonial-text">
                "Having access to decades of peer-reviewed NYSORA content at my fingertips has transformed my clinical practice. MAIA is the future of medical decision support."
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        
        <div className="testimonials-pagination"></div>
        
        {/* Navigation Arrows */}
        <div ref={prevRef} className="testimonials-button-prev">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="#9CA3AF"/>
          </svg>
        </div>
        <div ref={nextRef} className="testimonials-button-next">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.59 16.59L10 18L16 12L10 6L8.59 7.41L13.17 12L8.59 16.59Z" fill="#9CA3AF"/>
          </svg>
        </div>
      </div>
    </div>
      
    <div className="testimonials-disclaimer">
      MAIA is an educational tool and does not replace clinical judgment. All medical decisions should be confirmed using institutional protocols and current clinical guidelines.
    </div>
    
    {/* Footer Section */}
    <div style={{backgroundColor: 'white', marginTop: '0px !important', paddingTop: '0px !important'}}>
      <Footer />
    </div>
    </div>
  );
};

export default About; 